<template>
    <div v-if="curso.length">
        <div class="height-498 bg-center background-image" :style="`background-image: url(${curso[0].imagem})`" v-if="curso && curso[0] && curso[0].imagem"></div>
        
        <div class="container">

            <div class="row"> 
                <div class="col-12 col-lg-8 header-materia bg-white mb-5">
                    <div class="ml-xl-4 pl-xl-2 pt-4 mt-3">
                        <h1 class="font-56 font-glacial-bold">{{curso[0].nome}}</h1> 
                    </div>
                    <div class="ml-xl-4 pl-xl-2">
                        <h5 class="font-19 font-glacial-bold text-categories-red"><img src="/wp-content/themes/rhiza/src/assets/traco-laranja.png" class="px-2">{{curso[0].area}}</h5>
                    </div>
                </div>
            </div>

            <div class="row mb-5 pb-xl-3">
                <div class="col-12 font-24 font-18-mobile text-gray font-glacial-regular" v-html="jumpLine(curso[0].descricao)"></div>
            </div>

            <div class="row mb-5 pb-xl-3" v-if="curso[0].metodologia">
                <div class="col-12 font-24 font-18-mobile text-gray font-glacial-regular" v-html="jumpLine(curso[0].metodologia)"></div>
            </div>

            <div class="row mb-5 pb-xl-3" v-if="curso[0].mercado_trabalho">
                <div class="col-12 font-24 font-18-mobile text-gray font-glacial-regular" v-html="jumpLine(curso[0].mercado_trabalho)"></div>
            </div>

            <div class="d-flex justify-content-center pb-3 mb-5">
                <b-button variant="more-info" class="col-xl-2 mb-1 mt-4" :to="`/fale-conosco/${curso[0].id}`"/>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="row mb-xl-2 mb-lg-3 mb-4 pt-4 mt-1">
                        <div class="ml-3">
                            <h2 class="font-glacial-bold font-70 ml-xl-0 ml-3  mb-3 pb-2 mb-lg-0 pb-lg-0">
                                relacionados
                            </h2>
                        </div>
                    </div>
                </div>

                <div class="container-fluid mb-5 pb-5">
                    <div class="row justify-content-center">
                        <div class="col-xl-12 col-10">
                            <div ref="observerCursos"></div>
                            <transition enter-active-class="animated fadeInUp">
                                <slick class="slick-cursos" :options="slickOptions" v-if="showObserver && cursosRelacionados">
                                    <b-link class="mt-xl-5 pr-2 btn-cursos" :to="`/cursos/${d.area}/${d.slug}`" v-for="(d, index) in cursosRelacionados" :key="index">
                                        <div class="blog-item border-transparent border-radius-0 mt-3 mt-lg-0">
                                            <div  class="card-body card text-white card-cursos p-0 border-0 border-radius-0"
                                                :style="`background-image: url(${d.imagem})`">
                                            </div>
                                            <div class="row no-gutters text-overflow">
                                                <div class="col-xl-11 col-10 bg-white box-curso">
                                                    <h5 class="extra-bold mt-3 ml-3 mb-0 font-glacial-bold box-titulo">
                                                        {{d.nome}}
                                                    </h5>
                                                    <div class="arrow ml-3 mt-4 mb-4">
                                                        <img src="/wp-content/themes/rhiza/src/assets/arrow.png">
                                                    </div>
                                                    <div>
                                                        <div class="font-glacial-regular ml-3 descricao-curso">
                                                            {{d.descricao}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-link>
                                </slick>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            showObserver: false,
            slickOptions:{
                    arrows: true,
                    slidesToShow: 4,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings:{
                                slidesToShow: 1,
                            }
                        }
                    ]
                }
        }
    },

    methods:{
        routeTo(obj){
            this.$router.push(obj)
    
        },
        jumpLine(text){
            text = text.replace(/(?:\r\n|\r|\n)/g, '<br>');
            return text;
        },
        compare(a, b) {
            if ( a.area < b.area ){
                return -1;
            }
            if ( a.area > b.area ){
                return 1;
            }
            return 0;
        }
    },
    
    mounted(){
        var refInterval = setInterval(() => {
            if (!this.$refs.observerCursos) {
                return
            }
            
            var observer = new IntersectionObserver((entries) => {
                // If intersectionRatio is 0, the target is out of view
                // and we do not need to do anything.
                if (entries[0].intersectionRatio <= 0) {
                    return;
                }

                this.showObserver = true
                observer.unobserve(this.$refs.observerCursos)

            });

            observer.observe(this.$refs.observerCursos)

            clearInterval(refInterval);
        }, 250)

        if (this.curso.length > 0) {
            var arrTitle = document.title.split('|');
            var [baseTitle] = arrTitle.slice(-1);
            
            var d = document.createElement('div');
            d.innerHTML = `${this.curso[0].nome} | ${baseTitle}`
            document.title = d.innerText
        }
    },

    computed:{
        curso(){
            if(!this.$store.state.post.cursosApi || !this.$store.state.post.cursosApi.length) return []

            if (this.$route.params.slug) {
                return this.$store.state.post.cursosApi.filter(o => o.slug == this.$route.params.slug)
            }

            return this.$store.state.post.cursosApi.filter(o => o.area == this.$route.params.area)
        },

        cursos(){
            return this.$store.state.post.cursosApi
        },

        cursosRelacionados() {
            var arrArea = [], arrNotArea = [];
            if (this.$route.params.area) {
                arrArea    = this.$store.state.post.cursosApi.filter(o => o.area == this.$route.params.area).sort(() => Math.random() - 0.5)
                arrNotArea = this.$store.state.post.cursosApi.filter(o => o.area != this.$route.params.area).sort(() => Math.random() - 0.5)
            }
            
            return arrArea.concat(arrNotArea)
        }

    },
}
</script>
<style scoped>
.btn-cursos,
.btn-cursos:hover {
    color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/curso.vue